import { AnalyticsContext } from '@carvana/eventable-clickstream';
import { useContext } from 'react';
import type React from 'react';
import FavoriteVehicleComponent from '@/legacy/FavoriteVehicle';
import TileKit from '@/legacy/TileKit';
import VehicleImage from '@/legacy/VehicleImage';
import withHandleFavoriteV2 from '@/SearchResults/withHandleFavorite';
import Pills from './EVPill';
import Tags from './Tags';

const FavoriteVehicle = withHandleFavoriteV2(FavoriteVehicleComponent);

type BaseTopFrameProps = {};

const TopFrame: React.VFC<BaseTopFrameProps> = () => {
  const { trackEvent } = useContext(AnalyticsContext);

  return (
    <TileKit.Frame className="pointer-events-auto top-frame">
      <VehicleImage trackEvent={trackEvent} />
      <TileKit.Pane fullWidth>
        <Tags />
        <FavoriteVehicle />
        <Pills />
      </TileKit.Pane>
    </TileKit.Frame>
  );
};

export default TopFrame;
